@if (avDistribution === 'FREE' || avDistribution === 'PILOTED') {
  <form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
    <form-wrapper>
      @if (error && derrors) {
        <info [option]="optionInfo1">
          {{ error.message }}
        </info>
      }
      <ng-container formArrayName="products">
        @for (product of products.controls; track product; let index = $index) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <support
                [derrors]="derrors"
                [avDistribution]="avDistribution"
              ></support>
            </ng-container>
          </ng-container>
        }
      </ng-container>
    </form-wrapper>
    <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
  </form>
}
@if (avDistribution === 'PACK') {
  <simulation-packs-av></simulation-packs-av>
}
